import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, ViewChild, ViewChildren, OnChanges, QueryList } from '@angular/core';
import { GridsterConfig } from 'angular-gridster2';
import moment from 'moment';
import lodash_ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { GRIDSTER_CONFIG } from './gridster-config';
import { TranslateService } from '@ngx-translate/core';
import { SettingsConstants, SettingsService } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';
import { IsPeriodNavigatorService } from '../is-period-navigator/is-period-navigator.service';
import { Subscription } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { IsNoteFullscreenDialogService } from 'projects/is-ui-kit/src/lib/dialogs/is-note-fullscreen-dialog/is-note-fullscreen-dialog.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { queryParamsObjToString } from 'projects/is-ui-kit/src/lib/core/is-functions';

@Component({
  selector: 'is-data-experience',
  templateUrl: './data-experience.component.html',
  styleUrls: ['./data-experience.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IsDataExperienceComponent implements OnInit, OnChanges {
  // used in template
  public moment: any = moment;
  @ViewChild('picker', { static: false }) datePicker: MatDatepicker<any>;

  // hide or show elements
  @Input() public showDatePicker: boolean = true;
  @Input() public showPeriodPicker: boolean = true;
  @Input() public showEntityPicker: boolean = false;
  @Input() public dataExperienceId: number = 0;
  @Input() public dateNavigation = moment();
  @Input() public period: string = 'D';
  @Input() public dateFrom: any;
  @Input() public dateTo: any;
  @Input() public yearly: boolean = true;
  @Input() public entityID: number | string = 0;

  public showGrid: boolean = false;
  public currentDataExperience: any;
  public options: GridsterConfig = GRIDSTER_CONFIG;
  public layout = []; // list of blocks
  public originalLayout = [];
  public framesList: any = []; // list of frames that composed dataexperience
  public periodSelectControl = new UntypedFormControl();
  public entitySelectControl = new UntypedFormControl();
  public subscription: Subscription;
  // entity attributes
  public entitiesList: any = [];
  public entitiesListForSearch: any = [];
  public entity: any;
  public entityType: any;
  // world list property, useful to 'create frame' component
  public worldsList: any = [];

  // NOTES
  @Input() public dataExperienceName: string = '';
  @Input() public showNoteButtonInput: boolean = false;
  @ViewChild('viewGeneralNotesTrigger') viewGeneralNotesTrigger: MatMenuTrigger;
  @ViewChildren('addNoteTrigger', { read: MatMenuTrigger }) addNoteTrigger: QueryList<MatMenuTrigger>;
  @ViewChildren('viewFramesNotesTrigger', { read: MatMenuTrigger }) viewFramesNotesTrigger: QueryList<MatMenuTrigger>;
  public showNoteButton: boolean = false;
  public showNotePinnedIcon: boolean = false;
  public dataExperienceNotesList: any[] = [];
  public dataExperienceNotesListTotal: number = 0;
  public showOthersButtonGeneralNotes: boolean = false;
  public pageGeneralNotes: number = 1;
  public showNoteSpinner: boolean = false;
  public framesNotesList: any = {};

  public isDarkTheme: any = false;

  // default period and refresh
  public defaultFrequency = new UntypedFormControl('daily');
  public defaultDateControl = new UntypedFormControl(new Date);
  public defaultRangeControl = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });
  public defaultChoiceSet: boolean = true;

  constructor(
    private _http: HttpClient,
    public detector: ChangeDetectorRef,
    public translateService: TranslateService,
    private _datePicker: IsPeriodNavigatorService,
    private _isNoteFullscreenDialog: IsNoteFullscreenDialogService,
    private _cookie: CookieService,
    private _settingsService: SettingsService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._datePicker.parsedDate.subscribe((dateFromTo) => {
      this._setDateFromTo(dateFromTo, this._datePicker.getFrequency());
    });

    this.setEventListeners();
  }

  ngOnChanges(): void {
    this.startDataXpCycle();
  }

  // modifies queryParams to apply the selected time interval recieved as a parameter
  private _setDateFromTo(dateFromTo: [string, string], frequency: string): void {
    this.period = this.formatPeriod(frequency);
    this.dateFrom = dateFromTo[0];
    this.dateTo = dateFromTo[1];

    // update cookie with new time
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 14);
    this._cookie.put('dataXp_time', JSON.stringify({
      dataXp_from: dateFromTo[0],
      dataXp_to: dateFromTo[1],
      dataXp_freq: frequency
    }), { path: '/', expires: expirationDate });

    // create the iframes with new date param in url
    this.associateFrame();

    if (this.showNoteButtonInput && this.checkPermission('dataexperience.view_note')) {
      this.showNoteButton = true;
      // get data experience notes
      this.dataExperienceNotesList = [];
      this.dataExperienceNotesListTotal = 0;
      this.pageGeneralNotes = 1;
      this.getGeneralDataExperienceNotes();

      // get frames notes
      if (Object.keys(this.framesNotesList).length !== 0) {
        this.framesList.forEach((frame) => {
          this.framesNotesList[frame.id].pageNoteList = 1;
          this.getFrameNotes(frame.id);
        });
      }
    } else {
      this.showNoteButton = false;
    }
  }

  // set event listener for message came from iframes
  public setEventListeners(): void {
    window.addEventListener('message', (event: any) => {
      // include delete event
      if (event.data === 'delete') {
        this.getDataExperienceDetail();
      } else {
        this.modifyLayout(
          event.data.frame_id,
          event.data.open,
          event.data.onlyZoom
        );
      }
    });

    window.addEventListener('sidenav-toggled', (event: any) => {
      this.options?.api?.resize();
    });

    this.translateService.onLangChange.subscribe((x) => {
      this.startDataXpCycle();
    });
  }

  public modifyLayout(frameID, open, onlyZoom): void {
    const temp = lodash_.cloneDeep(this.layout);
    this.layout = [];
    setTimeout(() => {
      if (open) {
        for (const el of temp) {
          const elFrameID = parseInt(el.frame.id, 10);
          const intFrameID = parseInt(frameID, 10);

          if (el.frame && elFrameID === intFrameID) {
            el.cols = 24;
            el.rows = 11;
            el.y = 0;
            el.x = 0;
            const url = new URL(el.frame.chartUrl, location.origin);
            if (onlyZoom) {
              url.searchParams.set('opened', 'false');
              url.searchParams.set('zoomed', 'true');
            } else {
              url.searchParams.set('opened', 'true');
              url.searchParams.set('zoomed', 'true');
            }
            el.frame.chartUrl = url.toString();
            this.layout.push(el);
          }
        }
      } else {
        this.layout = [];
        for (const el of this.originalLayout) {
          if (el.frame) {
            const url = new URL(el.frame.chartUrl, location.origin);
            url.search = this.createParams(el.frame);
            url.searchParams.set('opened', open);
            url.searchParams.set('zoomed', open);
            el.frame.chartUrl = url.toString();
          }
          this.layout.push(el);
        }
      }
    }, 1000);
  }

  public startDataXpCycle(): void {
    this.showGrid = false;
    this.layout = [];
    this.framesList = [];
    this.currentDataExperience = {};

    // check if token is present
    if (this._cookie.get('token') && this._cookie.get('token').trim() !== '') {
      this.getworlds();
    }
  }

  // method to create the correct url with params
  public createApiUrl(frame, dateParams = null, period = null): string {
    // creating date params
    dateParams = moment(this.dateNavigation).startOf('date');
    // assigning period
    period = this.period;

    const config = JSON.parse(frame.configuration);
    let urlApi = `${SettingsConstants.BACKENDURL}/${config.general.url}?`;
    for (const key of Object.keys(config.params)) {
      urlApi += `${key}=${config.params[key]}&`;
    }
    urlApi += `&date_from=${this.dateFrom}&date_to=${this.dateTo}`;
    // if the url has "&" as last character, remove the last character
    if (urlApi.endsWith('&')) {
      urlApi = urlApi.slice(0, urlApi.length - 1);
    }
    return urlApi;
  }

  // get available worlds list
  public getworlds(): void {
    const url = `${SettingsConstants.BACKENDURL}/inspiring/isauth/api/user/available_worlds/`;
    const sub = this._http.get(url).subscribe({
      next: (data) => {
        this.worldsList = data;
      },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();

          this.getDataExperienceDetail();
        });
      }
    });
  }

  // get data experience detail
  public getDataExperienceDetail(loadDefaultPeriod: boolean = false): void {
    let temp = {};
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/data_experience/${this.dataExperienceId}`;
    const sub = this._http.get(url).subscribe({
      next: (data: any) => {
        temp = data;
      },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();

          this.currentDataExperience = temp;
          this.entity = this.currentDataExperience.entity;
          if (!this.entityID) {
            this.entityID = this.currentDataExperience.entity_id;
          }
          this.entityType = this.currentDataExperience.entity_type;

          if (this.showNoteButtonInput) {
            if (this.checkPermission('dataexperience.view_note')) {
              this.showNoteButton = true;
              // get data experience notes
              this.dataExperienceNotesList = [];
              this.dataExperienceNotesListTotal = 0;
              this.pageGeneralNotes = 1;
              this.getGeneralDataExperienceNotes();
            } else {
              this.showNoteButton = false;
            }
          }

          // check load default
          if (!loadDefaultPeriod) {
            // check dataXp_time cookie
            if (this._cookie.get('dataXp_time')) {
              // initialization date-picker with dataXp_time cookie
              this.loadCookieTime(JSON.parse(this._cookie.get('dataXp_time')));
            } else {
              // check default_view_period_unit
              if (this.currentDataExperience?.default_view_period_unit) {
                // initialization date-picker with default period
                this.loadDefaultPeriod(this.currentDataExperience);
              } else {
                // initialization date-picker with default daily
                this.defaultFrequency.setValue('daily');
                this.defaultDateControl.setValue(new Date);
                this.defaultRangeControl.patchValue({
                  start: new UntypedFormControl(),
                  end: new UntypedFormControl()
                });
                this.defaultChoiceSet = true;
                this.detector.detectChanges();
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                this._datePicker.setDate(today, 'daily');
              }
            }
          } else {
            // check default_view_period_unit
            if (this.currentDataExperience?.default_view_period_unit) {
              // initialization date-picker with default period
              this.loadDefaultPeriod(this.currentDataExperience);
            } else {
              // check dataXp_time cookie
              if (this._cookie.get('dataXp_time')) {
                // initialization date-picker with dataXp_time cookie
                this.loadCookieTime(JSON.parse(this._cookie.get('dataXp_time')));
              } else {
                // initialization date-picker with default daily
                this.defaultFrequency.setValue('daily');
                this.defaultDateControl.setValue(new Date);
                this.defaultRangeControl.patchValue({
                  start: new UntypedFormControl(),
                  end: new UntypedFormControl()
                });
                this.defaultChoiceSet = true;
                this.detector.detectChanges();
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                this._datePicker.setDate(today, 'daily');
              }
            }
          }

          this.currentDataExperience.configuration = this.currentDataExperience.configuration.replace(/'/g, `"`);
          let configuration;
          if (typeof this.currentDataExperience.configuration === 'string') {
            configuration = JSON.parse(
              this.currentDataExperience.configuration
            );
          }

          // extract the layout value from configuration
          this.layout = configuration.layout;
          this.originalLayout = configuration.layout;

          this.entitySelectControl.setValue(this.currentDataExperience.entity);

          const urlForFrames = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/frame/?dataxp=${this.dataExperienceId}`;
          const sub2 = this._http.get(urlForFrames).subscribe({
            next: (data) => {
              this.framesList = data;

              const isDarkThemeTemp = this.framesList.find((frame) => {
                if (frame?.configuration) {
                  if (JSON.parse(frame.configuration)?.theme === 'dark') {
                    return frame;
                  }
                }
              });
              if (isDarkThemeTemp !== undefined) {
                this.isDarkTheme = true;
              }

              if (this.showNoteButtonInput) {
                if (this.checkPermission('dataexperience.view_note')) {
                  this.showNoteButton = true;
                  // get frames notes
                  this.framesNotesList = {};
                  this.framesList.forEach((frame) => {
                    this.framesNotesList[frame.id] = {
                      notesList: [],
                      notesListTotal: 0,
                      pageNoteList: 1,
                      showOthersButton: false,
                      showSpinner: false,
                      showNoteChart: this.checkNoteChart(frame.type)
                    };
                    this.getFrameNotes(frame.id);
                  });
                } else {
                  this.showNoteButton = false;
                }
              }
            },
            error: () => {
              setTimeout(() => {
                sub2.unsubscribe();
              });
            },
            complete: () => {
              setTimeout(() => {
                sub2.unsubscribe();

                // saves the entitiesList
                this.getEntities();
              });
            }
          });
        });
      }
    });
  }

  // initialization date-picker with dataXp_time cookie
  public loadCookieTime(dataXpTimeCookie): void {
    dataXpTimeCookie['dataXp_from'] = new Date(dataXpTimeCookie['dataXp_from']);
    dataXpTimeCookie['dataXp_to'] = new Date(dataXpTimeCookie['dataXp_to']);

    this.defaultChoiceSet = true;
    this.defaultFrequency.setValue(dataXpTimeCookie['dataXp_freq']);
    this._datePicker.setFrequency(dataXpTimeCookie['dataXp_freq']);
    switch (dataXpTimeCookie['dataXp_freq']) {
      case 'daily':
        this.defaultDateControl.setValue(dataXpTimeCookie['dataXp_from']);
        this._datePicker.setDate(dataXpTimeCookie['dataXp_from'], dataXpTimeCookie['dataXp_freq']);
        break;
      case 'weekly':
        this.defaultDateControl.setValue(this.getMondayWeek(dataXpTimeCookie['dataXp_from']));
        this._datePicker.setDate(dataXpTimeCookie['dataXp_from'], dataXpTimeCookie['dataXp_freq']);
        break;
      case 'monthly':
        this.defaultDateControl.setValue(dataXpTimeCookie['dataXp_from']);
        this._datePicker.setDate(dataXpTimeCookie['dataXp_from'], dataXpTimeCookie['dataXp_freq']);
        break;
      case 'yearly':
        this.defaultDateControl.setValue(dataXpTimeCookie['dataXp_from']);
        this._datePicker.setDate(dataXpTimeCookie['dataXp_from'], dataXpTimeCookie['dataXp_freq']);
        break;
      case 'personalized':
        this.defaultChoiceSet = false;
        this.detector.detectChanges();
        this.defaultRangeControl.patchValue({
          start: dataXpTimeCookie['dataXp_from'],
          end: dataXpTimeCookie['dataXp_to']
        });
        const rangeStart = {
          start: dataXpTimeCookie['dataXp_from'],
          end: dataXpTimeCookie['dataXp_to']
        };
        this._datePicker.setRangeParsedDate(rangeStart);
        break;
    }
  }

  // initialization date-picker with default period
  public loadDefaultPeriod(dataXp): void {
    this.defaultFrequency.setValue('daily');
    this.defaultDateControl.setValue(new Date);
    this.defaultRangeControl.patchValue({
      start: new UntypedFormControl(),
      end: new UntypedFormControl()
    });
    this.defaultChoiceSet = null;
    this.detector.detectChanges();

    const today = new Date();
    if (dataXp.default_view_period === 0 || dataXp.default_view_period === null || dataXp.default_view_period === undefined) {
      this.defaultChoiceSet = true;
      this.detector.detectChanges();
      switch (dataXp.default_view_period_unit) {
        case 'daily':
          today.setHours(0, 0, 0, 0);
          this._datePicker.setDate(today, 'daily');
          break;
        case 'weekly':
          today.setHours(0, 0, 0, 0);
          this.defaultFrequency.setValue('weekly');
          this._datePicker.setFrequency('weekly');
          this._datePicker.setDate(today, 'weekly');
          this.defaultDateControl.setValue(this.getMondayWeek(today));
          break;
        case 'monthly':
          today.setHours(0, 0, 0, 0);
          this.defaultFrequency.setValue('monthly');
          this._datePicker.setFrequency('monthly');
          this._datePicker.setDate(today, 'monthly');
          break;
        case 'yearly':
          today.setHours(0, 0, 0, 0);
          this.defaultFrequency.setValue('yearly');
          this._datePicker.setFrequency('yearly');
          this._datePicker.setDate(today, 'yearly');
          break;
      }
    } else {
      // personalized period
      this.defaultChoiceSet = false;
      this.detector.detectChanges();
      this.defaultFrequency.setValue('personalized');
      this._datePicker.setFrequency('personalized');
      today.setHours(0, 0, 0, 0);
      let startDate;
      const finalDate = new Date(today);
      switch (dataXp.default_view_period_unit) {
        case 'daily':
          startDate = moment().add(-dataXp.default_view_period, 'day').startOf('day').toISOString();
          break;
        case 'weekly':
          startDate = moment().add(-dataXp.default_view_period, 'week').startOf('day').toISOString();
          break;
        case 'monthly':
          startDate = moment().add(-dataXp.default_view_period, 'month').startOf('day').toISOString();
          break;
        case 'yearly':
          startDate = moment().add(-dataXp.default_view_period, 'year').startOf('day').toISOString();
          break;
        default:
          startDate = moment().add(-dataXp.default_view_period, 'day').startOf('day').toISOString();
          break;
      }

      this.defaultRangeControl.patchValue({
        start: startDate,
        end: finalDate
      });
      const rangeStart = {
        start: startDate,
        end: finalDate
      };
      this._datePicker.setRangeParsedDate(rangeStart);
    }
  }

  public getMondayWeek(date): any {
    const actualDay = new Date(date);
    const diff = actualDay.getDay() - 1;
    actualDay.setDate(actualDay.getDate() - diff);
    return actualDay;
  }

  // get data experience entity list
  public getEntities(): void {
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/getentities/?dataxp_id=${this.dataExperienceId}`;
    const sub = this._http.get(url).subscribe({
      next: (data: any) => {
        this.entitiesList = data;
        this.entitiesListForSearch = data;
      },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();

          this.associateFrame();
        });
      }
    });
  }

  // associate frames to items, this method create the url for each iframe present in frameList
  public associateFrame(): void {
    for (const item of this.layout) {
      for (const frame of this.framesList) {
        if (item.id === frame.position) {
          // create url
          frame.chartUrl = `${origin}/${this._settingsService?.getPath(frame.module) ?
            this._settingsService?.getPath(frame.module) : frame.module}/${frame.type}/`;
          frame.chartUrl += `?frame_id=${frame.id}`;
          frame.chartUrl += `&token=${this._cookie.get('token')}`;
          frame.chartUrl += `&lang=${this.translateService.currentLang}`;
          frame.chartUrl += `&period=${this.formatPeriod(this.period)}`;
          frame.chartUrl += `&entity=${this.entity || ''}`;
          frame.chartUrl += `&entity_type=${this.entityType || ''}`;
          frame.chartUrl += `&entity_id=${this.entityID || ''}`;
          frame.chartUrl += `&date_from=${moment(this.dateFrom).toISOString() || ''}`;
          frame.chartUrl += `&date_to=${moment(this.dateTo).toISOString() || ''}`;
          frame.chartUrl += `&opened=false`;
          if (frame.chartUrl.includes('null') || frame.chartUrl === null) {
            frame.chartUrl = '';
          }
          item.frame = frame;
        }
      }
    }
    this.showGrid = true;
  }

  public createParams(frame): string {
    let url = '';
    url += `?frame_id=${frame.id}`;
    url += `&token=${this._cookie.get('token')}`;
    url += `&lang=${this.translateService.currentLang}`;
    url += `&period=${this.formatPeriod(this.period)}`;
    url += `&entity=${this.entity || ''}`;
    url += `&entity_type=${this.entityType || ''}`;
    url += `&entity_id=${this.entityID || ''}`;
    url += `&date_from=${moment(this.dateFrom).toISOString() || ''}`;
    url += `&date_to=${moment(this.dateTo).toISOString() || ''}`;
    return url;
  }

  public formatPeriod(freq): string {
    switch (freq) {
      case 'daily':
        return 'D';
      case 'weekly':
        return 'W';
      case 'monthly':
        return 'M';
      case 'yearly':
        return 'Y';
      default:
        return 'D';
    }
  }

  // change entity method
  public changeEntity(event): void {
    this.entityID = event.value.id;
    // create iframes
    this.associateFrame();
  }

  // filter entities
  public filterEntity(event: any): any {
    this.entitiesListForSearch = [];
    this.entitiesListForSearch = this.entitiesList.filter((x) => {
      if (x && x.name && x.name.toLowerCase().includes(event)) {
        return x;
      }
    });
  }

  // RESTORE DEFAULT PERIOD
  public restoreDefaultPeriod(): void {
    this.getDataExperienceDetail(true);
  }

  // REFRESH DATA EXPERIENCE
  public refreshDataExperience(): void {
    this.associateFrame();
  }

  // NOTES
  public createNote(note, frameId?): void {
    if (frameId) {
      note['entity'] = 'dataxpframe';
      note['entity_id'] = frameId;
      note['exact_entity'] = null;
      note['exact_entity_id'] = null;
    } else {
      note['entity'] = 'dataxp';
      note['entity_id'] = this.dataExperienceId;
      note['exact_entity'] = this.entity;
      note['exact_entity_id'] = this.entityID;
    }
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/`;
    this._http.post(url, note).subscribe({
      next: (data) => {
      },
      error: (err: Error) => {
        console.error(err);
      },
      complete: () => {
        if (frameId) {
          this.framesNotesList[frameId].pageNoteList = 1;
          this.getFrameNotes(frameId);
          this.addNoteTrigger.forEach((trigger) => {
            trigger.closeMenu();
          });
        } else {
          this.dataExperienceNotesList = [];
          this.dataExperienceNotesListTotal = 0;
          this.pageGeneralNotes = 1;
          this.getGeneralDataExperienceNotes();
        }
      }
    });
  }

  public deleteNote(idNote, frameId?): void {
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/${idNote}/`;
    this._http.delete(url).subscribe({
      next: (data) => {
      },
      error: (err: Error) => {
        console.error(err);
      },
      complete: () => {
        if (frameId) {
          this.framesNotesList[frameId].pageNoteList = 1;
          this.getFrameNotes(frameId);
        } else {
          this.dataExperienceNotesList = [];
          this.dataExperienceNotesListTotal = 0;
          this.pageGeneralNotes = 1;
          this.getGeneralDataExperienceNotes();
        }
      }
    });
  }

  public editNote(note, frameId?): void {
    const idNote = note.id;
    delete note['id'];
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/${idNote}/`;
    this._http.put(url, note).subscribe({
      next: (data) => {
      },
      error: (err: Error) => {
        console.error(err);
      },
      complete: () => {
        if (frameId) {
          this.framesNotesList[frameId].pageNoteList = 1;
          this.getFrameNotes(frameId);
        } else {
          this.dataExperienceNotesList = [];
          this.dataExperienceNotesListTotal = 0;
          this.pageGeneralNotes = 1;
          this.getGeneralDataExperienceNotes();
        }
      }
    });
  }

  public exportNoteList(noteList): void {
    let params = {};
    if (this._route.snapshot.queryParams) {
      params = _.cloneDeep(this._route.snapshot.queryParams);
    }
    params['request_format'] = 'excel';
    let idsList = [];
    idsList = noteList.map((el) => el.id);
    let queryParams = '?' + queryParamsObjToString(params);
    if (idsList.length !== 0) {
      queryParams = queryParams + '&ids=[' + idsList.join(',') + ']';
    }
    const url = `${SettingsConstants.HOST_NAME}${'/api/dataxp/v1/notes/'}${queryParams}`;
    window.open(url);
  }

  public getCurrentDateTime(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}_${hours}:${minutes}`;
  }

  public removeMarkupFromString(htmlString: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
  }

  // general notes
  public getGeneralDataExperienceNotes(queryParams: string = ''): void {
    this.showNoteSpinner = true;
    let temp: any;
    const dateFromTemp = moment(this.dateFrom).utcOffset(0).utc(true).format('YYYY-MM-DDTHH:mm:ss');
    const dateToTemp = moment(this.dateTo).utcOffset(0).utc(true).format('YYYY-MM-DDTHH:mm:ss');
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/data_experience/${this.dataExperienceId}/notes/?exact_entity=${this.entity}&exact_entity_id=${this.entityID}&page=${this.pageGeneralNotes}&valid_from=${dateFromTemp}&valid_to=${dateToTemp}`;
    this._http.get(url).subscribe({
      next: (data: any) => {
        temp = data;
      },
      error: (err: Error) => {
        console.error(err);
        this.showNoteSpinner = false;
      },
      complete: () => {
        this.showNotePinnedIcon = false;
        this.dataExperienceNotesListTotal = temp.count;
        if (this.pageGeneralNotes === 1) {
          this.dataExperienceNotesList = [];
        }
        this.dataExperienceNotesList = [...this.dataExperienceNotesList, ...temp.results];
        if (temp.next !== null) {
          this.showOthersButtonGeneralNotes = true;
        } else {
          this.showOthersButtonGeneralNotes = false;
        }
        const tempshowNotePinnedIcon = this.dataExperienceNotesList.find((nt) => nt.pinned === true);
        if (tempshowNotePinnedIcon !== undefined) {
          this.showNotePinnedIcon = true;
        }
        this.showNoteSpinner = false;
      }
    });
  }

  public loadOthersGeneralNotes(event): void {
    this.showOthersButtonGeneralNotes = false;
    this.pageGeneralNotes++;
    this.getGeneralDataExperienceNotes();
    event.stopPropagation();
  }

  public openGeneralNoteFullscreen(event): void {
    if (this.viewGeneralNotesTrigger.menuOpen) {
      this.viewGeneralNotesTrigger.closeMenu();
    }
    const obj = {
      dataExperienceGeneralNotes: true,
      dataExperienceVersion: 1,
      dataExperienceInfo: {
        dataExperienceId: this.dataExperienceId,
        dataExperienceName: this.dataExperienceName,
        entity: this.entity,
        entityID: this.entityID,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      }
    };
    this._isNoteFullscreenDialog.openIsNoteFullscreenDialog(obj, (result) => {
      this.dataExperienceNotesList = [];
      this.dataExperienceNotesListTotal = 0;
      this.pageGeneralNotes = 1;
      this.getGeneralDataExperienceNotes();
    });
  }

  public changeRefferedToGeneralNote(note): void {
    const idNote = note.id;
    if (note.entity === 'dataxp') {
      note['entity_id'] = this.dataExperienceId;
    } else if (note.entity === 'site') {
      note['entity_id'] = this.entityID;
    }
    delete note['id'];
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/${idNote}/`;
    this._http.put(url, note).subscribe({
      next: (data) => {
      },
      error: (err: Error) => {
        console.error(err);
      },
      complete: () => {
        this.dataExperienceNotesList = [];
        this.dataExperienceNotesListTotal = 0;
        this.pageGeneralNotes = 1;
        this.getGeneralDataExperienceNotes();
      }
    });
  }

  // for frame notes
  public getFrameNotes(frameId): void {
    this.framesNotesList[frameId].showSpinner = true;
    let temp: any;
    const dateFromTemp = moment(this.dateFrom).utcOffset(0).utc(true).format('YYYY-MM-DDTHH:mm:ss');
    const dateToTemp = moment(this.dateTo).utcOffset(0).utc(true).format('YYYY-MM-DDTHH:mm:ss');
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/frame/${frameId}/notes/?valid_from=${dateFromTemp}&valid_to=${dateToTemp}&page=${this.framesNotesList[frameId].pageNoteList}`;
    this._http.get(url).subscribe({
      next: (data: any) => {
        temp = data;
      },
      error: (err: Error) => {
        console.error(err);
        this.framesNotesList[frameId].showSpinner = false;
      },
      complete: () => {
        this.framesNotesList[frameId].notesListTotal = temp.count;
        if (this.framesNotesList[frameId].pageNoteList === 1) {
          this.framesNotesList[frameId].notesList = temp.results;
        } else {
          this.framesNotesList[frameId].notesList = [...this.framesNotesList[frameId].notesList, ...temp.results];
        }
        if (temp.next !== null) {
          this.framesNotesList[frameId].showOthersButton = true;
        } else {
          this.framesNotesList[frameId].showOthersButton = false;
        }
        this.framesNotesList[frameId].showSpinner = false;
      }
    });
  }

  public loadOthersFramesNotes(event, frameId): void {
    this.framesNotesList[frameId].showOthersButton = false;
    this.framesNotesList[frameId].pageNoteList++;
    this.getFrameNotes(frameId);
    event.stopPropagation();
  }

  public openFrameNoteFullscreen(event, frameId, item): void {
    this.viewFramesNotesTrigger.forEach((trigger) => {
      if (trigger.menuOpen) {
        trigger.closeMenu();
      }
    });
    const obj = {
      dataExperienceGeneralNotes: false,
      dataExperienceVersion: 1,
      dataExperienceInfo: {
        frameId: frameId,
        frameName: JSON.parse(item.frame.configuration).title,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      }
    };
    this._isNoteFullscreenDialog.openIsNoteFullscreenDialog(obj, (result) => {
      this.framesNotesList[frameId].pageNoteList = 1;
      this.getFrameNotes(frameId);
    });
  }

  public closeCreateNewNoteBuildingBlock(event): void {
    this.addNoteTrigger.forEach((trigger) => {
      trigger.closeMenu();
    });
  }

  public checkPermission(permissions: string | string[]): boolean {
    if (typeof (permissions) === 'string') {
      if (SettingsConstants.USERPERMISSIONS[permissions]) {
        return SettingsConstants.USERPERMISSIONS[permissions];
      } else {
        return false;
      }
    } else {
      for (let i = 0; i < permissions.length; i++) {
        if (!(permissions[i] in SettingsConstants.USERPERMISSIONS)) {
          return false;
        }
      }
      return true;
    }
  }

  public checkNoteChart(type): boolean {
    switch (type) {
      case 'gauge':
      case 'bar':
      case 'area':
      case 'pie':
      case 'table':
      case 'mini-card':
      case 'vertical-bar':
        return false;
      default:
        return true;
    }
  }
}
